import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getDocMoveProject, delDocMoveProjectById } from '../../../api/storage'
import { useCan } from '../../../hooks/useCan';
import { SLUGS } from '../../../enum/permissions.enum';

export default function MoveStorage(props) {
  const can = useCan();
  return (
    <div className='App-paper'>
      <PageList
        name='moveStorage'
        title='Документы перемещения материалов на  центральный склад'
        columns={[
          { id: 'id', name: '№' },
          { id: 'date', name: 'Дата', type: 'date' },
          { id: 'user', name: 'Создал' },
          { id: 'storageSpace', name: 'Склад' },
        ]}
        createItem={can(SLUGS.PROJECT.STORAGE.MOVE_CREATE)}
        deleteItem={can(SLUGS.PROJECT.STORAGE.MOVE_DELETE)}
        loadAPI={{
          param: {
            id: props.match.params.idProject
          },
          request: getDocMoveProject,
        }}
        deleteAPI={{
          path: delDocMoveProjectById(props.match.params.id).path,
          type: delDocMoveProjectById(props.match.params.id).type
        }}
        {...props}
      />
    </div>
  )
};


